export const blockIconsPrivacyandsecurityPrivacyTipNew = (
	<span className='material-symbols-outlined'>privacy_tip</span>
);
